<template>
  <v-app>
    <div class="bckdiv">
      <v-container>
          <v-layout align-center justify-center style="margin-top:200px">
              <v-flex xs12 md8>
                <h1 class="white--text " style="text-align:center">Looking for joy?</h1>
                <p class="white--text  mt-3" style="text-align:center">Your trusted trip companion</p>

              </v-flex>

             
                         </v-layout>
                         
              </v-container>
    </div>
    
    <v-container max>
      <v-layout row wrap style="margin-top:50px;text-align: center;">
        
              <v-flex class="mb-3" xs12 md12 lg12>
                
                <div class="why-us"> <h1 class="" style="text-align:center">Why Choose Us?</h1>
              <p class=" mt-3" style="text-align:center">These popular destinations have a lot to offer</p></div>
              </v-flex>

              <v-flex xs12 md4>
                <div class="why-us-box">
                  <div class="why-us-img">
                    <img src="https://creativelayers.net/themes/gotrip-html/img/featureIcons/1/1.svg" alt="">
                </div>
                  <h4>Best Price Guarantee</h4>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                </div>
              </v-flex>
              <v-flex xs12 md4>
                <div class="why-us-box">
                  <div class="why-us-img" >
                    <img src="https://creativelayers.net/themes/gotrip-html/img/featureIcons/1/2.svg" alt="">
                </div>
                  <h4>Easy & Quick Booking</h4>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                </div>
              </v-flex>
              <v-flex xs12 md4>
                <div class="why-us-box">
                  <div class="why-us-img">
                    <img src="https://creativelayers.net/themes/gotrip-html/img/featureIcons/1/3.svg" alt="">
                </div>
                <h4>Customer Care 24/7</h4>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                </div>
              </v-flex>

 
             
       </v-layout>


    </v-container>

    <v-container >
      <v-layout row wrap style="margin-top:50px;">
        

        <v-flex xs12 md5>
             <div class="about-us">
              <h1>About Bishnu Tours & Travels</h1>
               <p class="mb-4 heading-2 ">These popular destinations have a lot to offer</p>
                <p style="font-size: 14px;">Bishnu Tours and Travels an established name among the Tours & Travels operation Company of West Bengal . In the year 1976 Mr. Ananda Adhikary founded Bishnu Tours & Travels. It was his vision to facilitate people of West Bengal to travel to some of the best locations in India. Initially he have started our operation from Ranaghat a small town of Nadia District and then in the Year 1983 we establish our first corporate office at Kolkata and it was at No-8, Bentic Street ,Taher menssion Bulding Ground Floor. Then in the year 1996 we have shifted our office From Taher Menssion to Kamalalaya Centre, Room-F/66, First Floor,156A Lenin Sarani,Kolkata-13. Since then Bishnu Tours & Travels has operated thousands of tours all over India winning the hearts of tourists.</p>
                <p>Bishnu Tours & Travels has one motto and that is Customer Satisfaction. This has always given the tourist a confidence of traveling with our organization because traveling to a new location requires a lot of pre-planned arrangements and we have a team of specialized operators who knows the tourist requirements and looks after their needs in a very professional manner. The package tours organized by our organization is very much traveler – friendly and very economic.We provide Quality Hotel,all tipes of Bengali,Mughlai and Chinese Food and Good Deluxe Bus during the Tour. The tourists are also guided and briefed before traveling regarding the place and its importance.</p>
                <p>Bishnu Tours and Travels has been operating tours all over India and many International Locations also. Our company is LTC/LFC approved. We Organized Family tours, Group tour,Recreation Tour,School Students Group tour,College student Group Tour And Specially Corporate tours in regular basis. Some of the best tours for domestic and international locations are mention in our website.</p>
             </div>
        </v-flex>
        <v-flex xs12 md1>
        </v-flex>
        <v-flex xs12 md6>
          <img class="about-us-img" src="https://creativelayers.net/themes/gotrip-html/img/pages/about/2.png" alt="">
        </v-flex>
        <v-flex xs12 md12>
             <div class="about-us">
              <h2>Some of the major clients of Bishnu Tours & Travels:</h2>
               <p class="mb-4 heading-2 ">These popular destinations have a lot to offer</p>
               <p style="font-size: 14px;">Shyam Steel Ltd.Luna Tyre Pvt Ltd,Ashirbad Pipe,Balmarlawries Ltd,Calutta port Trust,Many Business Association and Some of other Goverment Organization Employees ( Punjab National Bank, State Bank Of India, Central Bank Of India, Allahabad Bank, Indian Bank, Bank Of India, Union Bank Of India, Bangio Gramin Bikesh Bank, Oriantal Bank Of Commerce, LICI, National Insurance, BSNL, Sail, Etc), So many School and college Students Group and Teachers Group.</p>

               <h2>Our Network</h2>
               <p>We provide easy access to the best talents with a wide spread network of offices located in all the major Places of West Bengal. While our Head offices is located at Kolkata and we have our branch Offices at Chanchal, Malda, Murshidabad, North Kolkata, Shirakole and Behrampur .We also have international associates in neighboring countries like Nepal, Bhutan and Thailand.</p>
                
               <h2>Infrastructure</h2>
               <p>We have our offices located in the central part of Kolkata. These offices are equipped with all the essential communication facilities including fax, telephones, broad band internet connections, computerized data bank and more. The customized software used for data ensures complete privacy of the clients with smooth and efficient data flow.</p>
               <h2>Team</h2>
               <p>We have a multifaceted team of highly experience recruitment consultants, who have specialization in different industries and sectors. Our team of consultants work in close coordination with the clients to conceptualize their requirements and offer them best solutions. Further, we also have a dedicated team of customer care, who attend all the queries of the clients and furnish them with complete information about the services.</p>

               <h2>Customer Satisfaction</h2>
               <p>While speed, dependability, reliability and efficiency are our priority, customer satisfaction is the ultimate goal. Our unique working methodology and untiring efforts rendering the best of present generation services.</p>
              </div>
        </v-flex>
 </v-layout>
    </v-container>
    <!-- <div >
       <v-container  style="max-width: 1400px;border-bottom: 1px solid #DDDDDD;">
        <v-layout row wrap>
          <v-flex xs12 md3 sm12 style="padding:20px" >
               <div class="box" >
                   <h1>4,958</h1>
                   <p>Destinations</p>
               </div>
          </v-flex>
          <v-flex xs12 md3 sm12 style="padding:20px" >
               <div class="box" >
                   <h1>2,869</h1>
                   <p>Total Properties</p>
               </div>
          </v-flex>
          <v-flex xs12 md3 sm12 style="padding:20px" >
               <div class="box" >
                   <h1>2M</h1>
                   <p>Happy customers</p>
               </div>
          </v-flex>
          <v-flex xs12 md3 sm12 style="padding:20px" >
               <div class="box" >
                   <h1>574,974</h1>
                   <p>Our Volunteers</p>
               </div>
          </v-flex>
        </v-layout>
       </v-container>
     </div> -->

    <v-container style="margin-top: 40px; max-width: 1400px;">
      <h1>Our Team</h1>
        <!-- <p>Lorem ipsum dolor sit amet</p> -->
      <v-layout row wrap >

          <v-flex xs12 class="team-card" md2 sm12 >
             <v-card style="background-color: transparent; box-shadow: none; ">
              <div >
                <img src="https://i.pinimg.com/originals/5f/40/6a/5f406ab25e8942cbe0da6485afd26b71.jpg" alt="">
                <h4>ANANDA ADHIKARY</h4>
                <!-- <p>Demo position</p> -->
              </div>
             </v-card>
          </v-flex>
          <v-flex xs12 class="team-card" md2 sm12 >
             <v-card style="background-color: transparent; box-shadow: none; ">
              <div >
                <img src="https://i.pinimg.com/originals/5f/40/6a/5f406ab25e8942cbe0da6485afd26b71.jpg" alt="">
                <h4>ANUPAM ADHIKARY</h4>
                <!-- <p>Demo position</p> -->
              </div>
             </v-card>
          </v-flex>
          <!-- <v-flex xs12 class="team-card" md2 sm12 >
             <v-card style="background-color: transparent; box-shadow: none; ">
              <div >
                <img src="https://i.pinimg.com/originals/5f/40/6a/5f406ab25e8942cbe0da6485afd26b71.jpg" alt="">
                <h4>Demo Name</h4>
                <p>Demo position</p>
              </div>
             </v-card>
          </v-flex>
          <v-flex xs12 class="team-card" md2 sm12 >
             <v-card style="background-color: transparent; box-shadow: none; ">
              <div >
                <img src="https://i.pinimg.com/originals/5f/40/6a/5f406ab25e8942cbe0da6485afd26b71.jpg" alt="">
                <h4>Demo Name</h4>
                <p>Demo position</p>
              </div>
             </v-card>
          </v-flex>
          <v-flex xs12 class="team-card" md2 sm12 >
             <v-card style="background-color: transparent; box-shadow: none; ">
              <div >
                <img src="https://i.pinimg.com/originals/5f/40/6a/5f406ab25e8942cbe0da6485afd26b71.jpg" alt="">
                <h4>Demo Name</h4>
                <p>Demo position</p>
              </div>
             </v-card>
          </v-flex>
          <v-flex xs12 class="team-card" md2 sm12 >
             <v-card style="background-color: transparent; box-shadow: none; ">
              <div >
                <img src="https://i.pinimg.com/originals/5f/40/6a/5f406ab25e8942cbe0da6485afd26b71.jpg" alt="">
                <h4>Demo Name</h4>
                <p>Demo position</p>
              </div>
             </v-card>
          </v-flex> -->

        </v-layout>
    </v-container>

    <div class="bottom">
      <v-container>
        <v-layout row wrap style="justify-content: center;">

          <v-flex xs12 class="about-bottom" md2 sm12 >

          </v-flex>
          </v-layout>
      </v-container>
    </div>

    </v-app>
</template>

<script>
import config from "./../../config.json";
export default {
  data() {
    return {
    };
  },
  
};
</script>

<style scoped>
@import '../../HomeCss/home.css';

@import url('https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap');
@import url('https://fonts.googleapis.com/css?family=Bree+Serif|Squada+One&display=swap');
</style>

<style scoped>
  v-app {
    font-family: 'Jost', sans-serif!important;

  }
.bgclr {
    width: 100%;
    height: 350px;
    background-image: linear-gradient(#7b1fa2, #e91e63);
}
.v-card {
  padding: 10px;
  border-radius: 8px;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.txtcntr {
  text-align: center;
}
.mrgn {
  margin-top: 50px;
}
h1.heading_1 {
  width: 100% !important;
}

.bg_clr {
  background-color: grey;
}

.heading_1 {
  font-family: 'Space Mono', monospace;
  text-align: center !important;
}
.main_icon {
  text-align: center !important;
}
.swo {
  box-shadow: none !important;
}
.opa {
  opacity: 1;
}
.why-us-img img{
 max-width: 100%;
 max-height: 100%;
 margin-bottom: 25px;
}
.about-us-img {
  max-width: 100%;
  border-radius: 5px;
}
.about-us {
  padding: 15px;
}
.about-us .heading-2 {
 
  color: #697488;

}
.why-us-box {
  padding:20px 50px;
}
.why-us p,.why-us-box p {
  color: #697488;
}
.box {
text-align: center;
}
.box h1 {
  color: #051036;
  font-weight: bold;
}
.box p {
  color: #697488;
}
.team-card {
  color:#051036;
}
.team-card img {
  height: 200px;
  width: 200px;
  border-radius: 5px;
  margin-bottom: 15px;
}
.hotel_name {
  font-family: 'Space Mono', monospace;
  font-weight: bold;
}
.enquiry {
    font-family: 'Bree Serif', serif;
}
.contact_tag {
    font-family: 'Space Mono', monospace;
}
.bckdiv {
    background-image: url("../../assets/contact.jpg");
    height: 400px;
    background-size: cover;
}
@media screen and (max-width: 763px) {
  .rspnsv {
    width: 100%;
    height: auto;
    margin-bottom: 20px;
    background-position: center;
    background-size: cover;
  }
  .team-card {
    text-align: center;
  }
  .help {
    padding-right: 0px !important;
  }
  .aboutTop {
      margin-top: 180px;
      margin-bottom: 100px;
  }
}
@media screen and (min-width: 768px){
  .xyz {
      height: 625px;
  }
}
</style>
